var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.header.hideHeader
    ? _c(
        "div",
        {
          staticClass: "ns-header",
          class: { "show-search-results": _vm.showSearchResults }
        },
        [
          _c(
            "header",
            {
              staticClass: "header-container",
              class: {
                rtl: _vm.dir === "rtl",
                "hide-header-center-top": _vm.header.hideTopCenter
              },
              attrs: { id: _vm.header.id }
            },
            [
              !_vm.desktop &&
              !_vm.header.hideUtilityBar &&
              (_vm.header.marketingMessage.info ||
                _vm.header.marketingMessage.link)
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showMobileMarketingMessage,
                          expression: "showMobileMarketingMessage"
                        }
                      ],
                      staticClass: "utility-bar-area"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "header-max-width utility-bar-body" },
                        [
                          !_vm.header.hideTopCenter
                            ? _c(
                                "div",
                                { staticClass: "utility-bar-item top-center" },
                                [
                                  _vm._t("top-center", [
                                    !_vm.header.hideMarketingMessage
                                      ? _c("NsHeaderMarketingMessage", {
                                          attrs: {
                                            message: _vm.header.marketingMessage
                                          },
                                          on: {
                                            close: _vm.closeMarketingMessage
                                          }
                                        })
                                      : _vm._e()
                                  ])
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.desktop && !_vm.header.hideUtilityBar
                ? _c("div", { staticClass: "utility-bar-area" }, [
                    _c(
                      "div",
                      {
                        staticClass: "header-max-width utility-bar-body",
                        class: [_vm.utilityBarCenterClass]
                      },
                      [
                        !_vm.header.hideTopLeft
                          ? _c(
                              "div",
                              { staticClass: "utility-bar-item top-left" },
                              [
                                _vm._t("top-left", [
                                  (!_vm.header.hideLegalLinks &&
                                    _vm.header.legalLinks.length > 0) ||
                                  _vm.header.accessibilityLink
                                    .showAccessibilityLink === true
                                    ? _c("NsHeaderLegalLinks", {
                                        attrs: {
                                          links: _vm.header.legalLinks,
                                          "accessibility-link":
                                            _vm.header.accessibilityLink,
                                          "hide-legal-links":
                                            _vm.header.hideLegalLinks
                                        }
                                      })
                                    : _vm._e()
                                ])
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.header.hideTopCenter
                          ? _c(
                              "div",
                              { staticClass: "utility-bar-item top-center" },
                              [
                                _vm._t("top-center", [
                                  !_vm.header.hideMarketingMessage
                                    ? _c("NsHeaderMarketingMessage", {
                                        attrs: {
                                          message: _vm.header.marketingMessage
                                        },
                                        on: { close: _vm.closeMarketingMessage }
                                      })
                                    : _vm._e()
                                ])
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.header.hideTopRight
                          ? _c(
                              "div",
                              { staticClass: "utility-bar-item top-right" },
                              [
                                _vm._t("top-right", [
                                  !_vm.header.hideRegionSelector
                                    ? _c("NsHeaderRegionSelector", {
                                        attrs: {
                                          "href-override": _vm.header.homeUrl,
                                          region: _vm.header.region,
                                          "region-selector-path":
                                            _vm.header.regionSelectorPath,
                                          "regions-allowed":
                                            _vm.header.regionsAllowed,
                                          translations: _vm.header.translations
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._t("profile", [
                                    !_vm.header.hideProfile
                                      ? _c("NsHeaderProfileDropdown", {
                                          staticClass: "ns-profile",
                                          attrs: {
                                            "hide-sign-up":
                                              _vm.header.hideSignUp,
                                            "profile-menu":
                                              _vm.header.profileMenu,
                                            "sign-out-url":
                                              _vm.header.signOutUrl,
                                            "sign-up-url": _vm.header.signUpUrl,
                                            translations:
                                              _vm.header.profileTranslations
                                          }
                                        })
                                      : _vm._e()
                                  ])
                                ])
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "header-body" }, [
                _c(
                  "div",
                  { staticClass: "header-layout header-max-width" },
                  [
                    _vm._t("header", [
                      !_vm.header.hideBottomLeft
                        ? _c(
                            "div",
                            { staticClass: "header-left" },
                            [
                              _vm._t("left", [
                                _c(
                                  "div",
                                  { staticClass: "header-left-one" },
                                  [
                                    _vm._t("left-one", [
                                      !_vm.header.hideMenu &&
                                      !(
                                        _vm.header.hideUtilityBar &&
                                        _vm.header.hideTopNav
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "menu-button",
                                              class: "open-" + _vm.isMenuOpen,
                                              on: { click: _vm.toggleMenu }
                                            },
                                            [
                                              _c("NsIcon", {
                                                attrs: {
                                                  "icon-name": "icon-hamburger"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ])
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                !_vm.hideLogo
                                  ? _c(
                                      "div",
                                      { staticClass: "header-left-two" },
                                      [
                                        _vm._t("left-two", [
                                          _c("NsLogo", {
                                            attrs: {
                                              "is-mysite":
                                                _vm.header.distributorImage ||
                                                _vm.useMysiteHeader ||
                                                _vm.isHeaderDataMysite
                                                  ? true
                                                  : false,
                                              "mysite-image-url":
                                                _vm.header.distributorImage,
                                              "link-url": _vm.disableLogoLink
                                                ? ""
                                                : _vm.header.homeUrl || "/",
                                              "alt-text":
                                                _vm.header.distributorImage ||
                                                _vm.useMysiteHeader ||
                                                _vm.isHeaderDataMysite
                                                  ? "Nu Skin Logo on the Mysite Header"
                                                  : "Nu Skin Logo on the Header",
                                              "is-market-logo-override":
                                                _vm.marketOverrideCondition &&
                                                !(
                                                  _vm.header.distributorImage ||
                                                  _vm.useMysiteHeader ||
                                                  _vm.isHeaderDataMysite
                                                )
                                                  ? true
                                                  : false,
                                              "market-logo-desktop-url": _vm.marketOverrideCondition
                                                ? "https://media.nuskin.com/m/67cf60cef6134c90/original/japan_30_anniversary_desktop.png"
                                                : "",
                                              "market-logo-mobile-url": _vm.marketOverrideCondition
                                                ? "https://media.nuskin.com/m/62008b0b85bdedc5/original/japan_30_anniversary_mobile.png"
                                                : "",
                                              "is-word-mark": !(
                                                _vm.marketOverrideCondition ||
                                                _vm.header.distributorImage ||
                                                _vm.useMysiteHeader ||
                                                _vm.isHeaderDataMysite
                                              )
                                                ? true
                                                : false
                                            }
                                          })
                                        ])
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ])
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.header.hideBottomCenter
                        ? _c(
                            "div",
                            { staticClass: "header-center" },
                            [
                              _vm._t("center", [
                                _c(
                                  "div",
                                  { staticClass: "header-center-top" },
                                  [
                                    _vm._t("center-top", [
                                      !_vm.header.hideSearchBar
                                        ? _c("NsSearchbar", {
                                            ref: "searchbar",
                                            staticClass: "ns-searchbar",
                                            attrs: {
                                              "disable-predictive-search":
                                                _vm.header
                                                  .disablePredictiveSearch,
                                              translations:
                                                _vm.header
                                                  .searchbarTranslations,
                                              "popular-search-array":
                                                _vm.header.popularSearchArray,
                                              "hide-see-more-results":
                                                _vm.header.hideSeeMoreResults,
                                              "using-tooltips":
                                                _vm.header.showToolTip,
                                              "order-type-in-predictive":
                                                _vm.header
                                                  .orderTypeInPredictive,
                                              "search-options":
                                                _vm.header.searchOptions,
                                              "new-header": ""
                                            },
                                            on: {
                                              "close-search-results":
                                                _vm.handleCloseSearchResults
                                            }
                                          })
                                        : _vm._e()
                                    ])
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.desktop
                                  ? _c(
                                      "div",
                                      { staticClass: "header-center-bottom" },
                                      [
                                        _vm._t("center-bottom", [
                                          !_vm.header.hideTopNav
                                            ? _c(
                                                "div",
                                                [
                                                  _c("NsTopnav", {
                                                    attrs: {
                                                      "local-navigation":
                                                        _vm.header.navigation,
                                                      "use-top-level-nav":
                                                        _vm.useTopLevelNav
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ])
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ])
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.header.hideBottomRight
                        ? _c(
                            "div",
                            { staticClass: "header-right" },
                            [
                              _vm._t("right", [
                                _c(
                                  "div",
                                  { staticClass: "header-right-one" },
                                  [
                                    _vm._t("right-one", [
                                      !_vm.header.hideJoinUs &&
                                      _vm.header.joinUs.label &&
                                      _vm.header.joinUs.link
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "join-link",
                                              attrs: {
                                                href: _vm.header.joinUs.link
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.header.joinUs.label
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.header.hideLoyalty
                                        ? _c("NsHeaderLoyaltyRewards", {
                                            attrs: {
                                              translations:
                                                _vm.header.translations
                                            }
                                          })
                                        : _vm._e()
                                    ])
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "header-right-two" },
                                  [
                                    _vm._t("right-two", [
                                      !_vm.header.hideCart
                                        ? _c("NsMiniCart", {
                                            staticClass: "ns-mini-cart",
                                            attrs: {
                                              "shopping-bag-text":
                                                _vm.header.cartText,
                                              "show-shopping-bag-text":
                                                _vm.header.showCartText
                                            }
                                          })
                                        : _vm._e()
                                    ])
                                  ],
                                  2
                                )
                              ])
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              !_vm.desktop &&
              !(_vm.header.hideUtilityBar && _vm.header.hideTopNav)
                ? _c(
                    "NsDrawer",
                    {
                      attrs: { open: _vm.mobileDrawerOpen, width: "300" },
                      on: {
                        close: function($event) {
                          _vm.mobileDrawerOpen = false
                        }
                      }
                    },
                    [
                      _c("NsHeaderDrawer", {
                        attrs: {
                          navigation: _vm.header.navigation,
                          region: _vm.header.region,
                          "href-override": _vm.header.homeUrl,
                          "regions-allowed": _vm.header.regionsAllowed,
                          "region-selector-path": _vm.header.regionSelectorPath,
                          "signup-href": _vm.header.signUpUrl,
                          translations: _vm.header.translations,
                          "join-us": _vm.header.joinUs,
                          "legal-links": _vm.header.legalLinks,
                          "hide-top-nav": _vm.header.hideTopNav,
                          "hide-legal-links":
                            _vm.header.hideLegalLinks ||
                            _vm.header.hideUtilityBar,
                          "hide-loyalty": _vm.header.hideLoyalty,
                          "hide-region-selector":
                            _vm.header.hideRegionSelector ||
                            _vm.header.hideUtilityBar,
                          "hide-join-us": _vm.header.hideJoinUs,
                          "hide-footer-nav": "",
                          "hide-footer-signup": ""
                        },
                        on: {
                          "close-drawer": function($event) {
                            _vm.mobileDrawerOpen = false
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function() {
                                return [
                                  !_vm.header.hideProfile &&
                                  !_vm.header.hideUtilityBar &&
                                  !_vm.desktop
                                    ? _c("NsHeaderProfileDropdownMobile", {
                                        attrs: {
                                          "hide-sign-up": _vm.header.hideSignUp,
                                          "profile-menu":
                                            _vm.header.profileMenu,
                                          "sign-out-url": _vm.header.signOutUrl,
                                          "sign-up-url": _vm.header.signUpUrl,
                                          translations:
                                            _vm.header.profileTranslations
                                        },
                                        on: {
                                          "close-drawer": function($event) {
                                            _vm.mobileDrawerOpen = false
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          663422945
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { ref: "searchResults", staticClass: "header-search-results" },
            [
              _vm._t("search-results", [
                _c("NsSearchResults", {
                  attrs: {
                    "show-search-results": _vm.showSearchResults,
                    translations: _vm.header.searchResultsTranslations
                  },
                  on: {
                    "scroll-to-top": _vm.scrollToTopOfSearchResults,
                    "back-button-clicked": _vm.handleBackButtonClicked
                  }
                })
              ])
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }